<div class="flex items-center justify-center" style="margin-top: 4.5rem">
  <p-fluid>
    <div class="flex items-center justify-center w-full">
      <div class="w-full max-w-xl rounded-xl">
        <div class="card flex flex-col items-center gap-4 p-6">
          <i [class]="iconClass()" style="font-size: 4.5rem"></i>
          <div class="font-semibold text-3xl text-center">
            {{ titleKey() | transloco }}
          </div>
          <div class="font-normal text-lg text-center">
            {{ messageKey() | transloco }}
          </div>
        </div>
      </div>
    </div>
  </p-fluid>
</div>
